import React, { useState } from "react";
import Dropdown from "../../components/CustomFields/Dropdown";
import InputField from "../../components/CustomFields/InputField";

const ParentDetails = ({ applicant, handleNestedChange, errors }) => {
  const parentTypeOptions = [
    { value: "", label: "Select Parent Type" },
    { value: "FATHER", label: "Father" },
    { value: "MOTHER", label: "Mother" },
    { value: "GUARDIAN", label: "Guardian" },
    // { value: "OTHER", label: "Other" }
  ];

  const initialParent = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    occupation: "",
    annualIncome: "",
    type: ""
  };

  const [parentList, setParentList] = useState(
    applicant.parentList && applicant.parentList.length > 0
      ? applicant.parentList
      : [initialParent]
  );

  const addParent = () => {
    const updatedParentList = [...parentList, { ...initialParent }];
    setParentList(updatedParentList);
    handleNestedChange("parentList", null, null, updatedParentList);
  };

  const removeParent = (index) => {
    if (parentList.length <= 1) return;
    const updatedParentList = parentList.filter((_, i) => i !== index);
    setParentList(updatedParentList);
    handleNestedChange("parentList", null, null, updatedParentList);
  };

  const handleParentChange = (index, field, value) => {
    const updatedParentList = parentList.map((parent, i) =>
      i === index ? { ...parent, [field]: value } : parent
    );
    setParentList(updatedParentList);
    handleNestedChange("parentList", null, null, updatedParentList);
  };

  // Used to filter out already selected parent types
  const getAvailableOptions = (index) => {
    const selectedTypes = parentList
      .map((p, i) => (i !== index ? p.type : null))
      .filter(Boolean);
    return parentTypeOptions.filter((opt) => !selectedTypes.includes(opt.value));
  };

  const handlePhoneNumberChange = (index, value) => {
    const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
    handleParentChange(index, "phoneNumber", digitsOnly);
  };


  return (
    <section>
      <h2 className="text-xl font-bold mb-4">Parent Details</h2>

      {parentList.map((parent, index) => {
        const parentErrors = errors?.parentList?.[index] || {};
        const parentType = parent.type
          ? parent.type.charAt(0) + parent.type.slice(1).toLowerCase()
          : "";

        return (
          <div key={index} className="mb-6 pb-4 border-b last:border-b-0">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <Dropdown
                label="Relationship With Student"
                name={`parentList[${index}].type`}
                options={getAvailableOptions(index)}
                value={parent.type || ""}
                onChange={(e) => handleParentChange(index, "type", e.target.value)}
                error={parentErrors.type}
              />
              {parentList.length > 1 && (
                <div className="flex items-end">
                  <button
                    type="button"
                    onClick={() => removeParent(index)}
                    className="text-red-500 hover:text-red-700 text-sm flex items-center"
                  >
                    <svg
                      className="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                    Remove
                  </button>
                </div>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <InputField
                label={`${parentType}'s First Name *`}
                name={`parentList[${index}].firstName`}
                value={parent.firstName || ""}
                onChange={(e) =>
                  handleParentChange(index, "firstName", e.target.value)
                }
                error={parentErrors.firstName}
              />
              <InputField
                label={`${parentType}'s Last Name *`}
                name={`parentList[${index}].lastName`}
                value={parent.lastName || ""}
                onChange={(e) =>
                  handleParentChange(index, "lastName", e.target.value)
                }
                error={parentErrors.lastName}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <InputField
                label={`${parentType}'s Email *`}
                name={`parentList[${index}].email`}
                type="email"
                value={parent.email || ""}
                onChange={(e) =>
                  handleParentChange(index, "email", e.target.value)
                }
                error={parentErrors.email}
              />
              <InputField
                label={`${parentType}'s Mobile Number *`}
                name={`parentList[${index}].phoneNumber`}
                type="number"
                className="pl-14 pr-4 py-2 border rounded w-full"
                maxLength={10}
                value={parent.phoneNumber || ""}
                onChange={(e) => handlePhoneNumberChange(index, e.target.value)}
                placeholder="Enter 10-digit number"
                error={parentErrors.phoneNumber}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <InputField
                label={`${parentType}'s Occupation *`}
                name={`parentList[${index}].occupation`}
                value={parent.occupation || ""}
                onChange={(e) =>
                  handleParentChange(index, "occupation", e.target.value)
                }
                error={parentErrors.occupation}
              />
              <InputField
                label={`${parentType}'s Annual Income *`}
                name={`parentList[${index}].annualIncome`}
                value={parent.annualIncome || ""}
                type="number"
                onChange={(e) =>
                  handleParentChange(index, "annualIncome", e.target.value)
                }
                error={parentErrors.annualIncome}
              />
            </div>
          </div>
        );
      })}

      {/* Add button at the end */}
      <div className="flex justify-end mt-4">
        <button
          type="button"
          onClick={addParent}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center text-sm"
        >
          <svg
            className="h-5 w-5 mr-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
          Add Parent Detail
        </button>
      </div>
    </section>
  );
};

export default ParentDetails;
